import { InlineStack, Link } from '@customerio/pluma-components/react';
import { useOptionalCopilotSession } from '../components/session-context';
import { useQueryBuilderModal } from './query-builder-modal';

type AnalyticsQueryLinkProps = {
  question: string;
  spec: string;
  /** The workspace the agent ran the query in; null when the agent did not say. */
  workspaceId: number | null;
};

/**
 * The "View and edit this query" link the agent places under an analytics
 * answer. It carries the spec as the agent restated it in the component call,
 * and the workspace the agent ran it in; the modal asks the server to compile
 * that spec there, so the SQL shown is derived from the spec and never written
 * by the agent. An edited query goes back into this conversation as the
 * customer's next turn. Sourcing the spec and workspace from the recorded tool
 * call instead of the agent's restatement is a later slice.
 */
export function AnalyticsQueryLink({ question, spec, workspaceId }: AnalyticsQueryLinkProps) {
  const modal = useQueryBuilderModal();
  const session = useOptionalCopilotSession();

  return (
    <InlineStack gap="100" alignBlock="center">
      <Link
        onClick={() =>
          modal.open({
            question,
            spec,
            workspaceId,
            conversationId: session?.id ?? null,
            send: session == null ? null : (message: string) => session.sendMessage(message),
          })
        }
        icon="database"
        variant="secondary"
      >
        View and edit this query
      </Link>
    </InlineStack>
  );
}
